export var DEFAULTS_MODE_OPTIONS = ["in-region", "cross-region", "mobile", "standard", "legacy"];



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/util-defaults-mode-browser/dist-es/constants.js
// module id = 759
// module chunks = 0